import React, { useRef } from 'react';
import Input from '@/components/input/Input';
import Button from '@/components/input/Button';
import { RemoveCircle, ViewCompact } from '@mui/icons-material';
import { useSortDrag, useSortDrop } from '@/hooks/useSortDnD';
import theme from '@/constants/theme';

interface Props {
  option: string;
  optIndex: number;
  index: number;
  moveOption: (fromIndex: number, toIndex: number) => void;
  handleChangeOptions: (optionIndex: number) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  removeOption: (optIndex: number) => void;
  questionId: string;
}

const Option: React.FC<Props> = ({
  index,
  option,
  optIndex,
  questionId,
  moveOption,
  handleChangeOptions,
  removeOption,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const dragHandleRef = useRef<HTMLSpanElement>(null);

  const [, drop] = useSortDrop({
    ref: ref as React.RefObject<HTMLDivElement>,
    index,
    moveItem: moveOption,
    name: `option-${questionId}`,
  });

  const [, drag] = useSortDrag({
    index,
    name: `option-${questionId}`,
  });

  drop(ref);
  drag(dragHandleRef);

  return (
    <div ref={ref} key={optIndex} style={{ display: 'flex', gap: 8, width: '100%', alignItems: 'center' }}>
      <span ref={dragHandleRef} style={{ cursor: 'grab', color: theme.colors.text.caption }}>
        <ViewCompact />
      </span>
      <Input
        value={option}
        onChange={handleChangeOptions(optIndex)}
        sx={{ flex: 1, height: 36 }}
      />
      <Button
        type="button"
        variant="ghost"
        size="small"
        Icon={RemoveCircle}
        onClick={() => removeOption(optIndex)}
      >
        Remover opción
      </Button>
    </div>
  );
};

export default Option;
